import Vue from 'vue';
import v1 from 'uuid/v1';
import v4 from 'uuid/v4';
import v5 from 'uuid/v5';

export const uuid = { v1, v4, v5 };

Vue.use({
  install(vue) {
    vue.prototype.$uuid = uuid;
  },
});
